import React from 'react';

const HallOfFamePage = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Hall of Fame</h2>
      <p>Top creators, most viral coins, and legendary meme wins will be displayed here.</p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '700px',
    margin: '0 auto',
    padding: '2rem',
    fontFamily: 'VT323',
    color: '#f0f0f0',
  },
  heading: {
    fontSize: '2rem',
    color: '#FAFF00',
    marginBottom: '1rem',
  },
};

export default HallOfFamePage;
